import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

import './Slide.css';

export default class Slide extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    modifyChild: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    modifyChild: true
  };

  componentDidMount() {
    const { modifyChild } = this.props;
    const node = findDOMNode(this);
    if (node && modifyChild) {
      Object.assign(node.dataset, this.getProps());
    }
  }

  getProps = (prefix='') => {
    let props = {};
    props[`${prefix}name`] = 'Slide';

    if (this.props.x) {
      props[`${prefix}translatex`] = true;
      props[`${prefix}val${this.props.x}`] = true;
    }

    if (this.props.y) {
      props[`${prefix}translatey`] = true;
      props[`${prefix}val${this.props.y}`] = true;
    }

    return props;
  }

  render() {
    const { modifyChild, children } = this.props;

    if (modifyChild) {
      return children;
    }

    return (
      <div {...this.getProps('data-')}>
        {children}
      </div>
    );
  }

}
